/**
 * Filter function to check whether two scheduled dates and times overlap
 * schedule and instance objects must have a date, startTime and endTime e.g.
 * {
 *     date: 15-09-2020,
 *     startTime: 12:00
 *     endTime: 12:30
 * }
 * Params:
 * schedule - array object with all dates and times
 * instance - object to check against
 * index - index of instance in object - optional, if instance is an object in schedule
 */

(function() {
    'use strict';

    angular.module('app').filter('scheduleConflict', function() {
        return function (schedule, instance, index) {
            var _schedule = angular.copy(schedule);
            if(typeof index !== 'undefined'){
                _schedule.splice(index, 1);
            }
            for(var i = 0; i < _schedule.length; i++){
                if(instance.date !== null && Date.parse(instance.date) === Date.parse(_schedule[i].date)){
                    if(instance.startTime !== null && _schedule[i].startTime !== null &&
                        ((instance.startTime >= _schedule[i].startTime && instance.startTime <= _schedule[i].endTime) ||
                        (_schedule[i].startTime >= instance.startTime && _schedule[i].startTime <= instance.endTime))
                    ){
                        return true;
                    }
                }
            }
            return false;
        };
    });

}());